import styled from '@xstyled/styled-components';
import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Item, registry, RenderProps } from '../Item';
import { PDF } from '../itemIds';
import { EditorMediaFile, useEditorStore } from '~/shell/Store';
import { EditBtn, EditBtnIcon } from '~/editor/buttons/EditBtn';
import FilePickerV2 from '~/editor/filePicker/FilePicker_v2';
interface Props {
  mediaUrl?: string;
}

const Wrapper = styled.div`
  width: 95%;
  height: 65%;

  .pdf {
    // width: 100%;
    // aspect-ratio: 4 / 3;
  }
  .pdf,
  iframe {
    width: 100%;
    height: 100%;
  }
  html,
  body {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;

export class Pdf extends Item<typeof PDF, Props> {
  protected render({ id, mediaUrl }: RenderProps<Props>) {
    const { contentEditable, updateFile } = useEditorStore();
    const divElRef = useRef<HTMLDivElement>(null);
    const fileElRef = useRef<HTMLDivElement>(null);
    const [showFilePicker, setShowFilePicker] = useState(false);

    const compStyle = {
      position: 'relative',
      zIndex: 199,
      width: '28px',
      float: 'right',
      marginTop: '-16px',
      marginBottom: '16px'
    };

    const UpdateFileElement = (file: EditorMediaFile) => {
      updateFile(id, file, 'documents');
      setShowFilePicker(false);
    };

    return (
      <Wrapper ref={divElRef}>
        {contentEditable && (
          <EditBtn
            onClick={() => setShowFilePicker(!showFilePicker)}
            style={compStyle as React.CSSProperties}
            className="edit-bg-btn"
          >
            <EditBtnIcon />
          </EditBtn>
        )}
        {/* <object
          className="pdf"
          data={mediaUrl}
          width="800"
          height="500"
        ></object> */}

        <iframe
          src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${mediaUrl}`}
          width="100%"
          height="500"
          style={{ border: 'none' }}
        ></iframe>
        {showFilePicker &&
          createPortal(
            <FilePickerV2
              fileElRef={fileElRef}
              updateFile={UpdateFileElement}
              type="document"
              onClose={() => setShowFilePicker(false)}
            />,
            document.body
          )}
      </Wrapper>
    );
  }
}

registry[PDF] = Pdf;
